export const isEnglishLang = () => {
  if ("navigator" in window) {
    return navigator.language.toLowerCase().startsWith("en-");
  }
  // default return true if navigator is not available
  return true;
};
